import styled from '@emotion/styled';

const ModalConfirmVersionStyle = styled('div')`
    .contentModal {
        color: #4f4f4f;
        font-size: 16px;
        font-weight: 400;
    }
    .quoteTitle {
        color: #069;
        font-size: 16px;
        font-weight: 400;
    }
    .btnEdit {
        margin-right: 16px;
    }
    .text-require{
        color: #CC3027;
    }
    
    .groupBtn {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin-top: 24px;
    }
    .groupInput {
        margin-top: 24px;
        margin-bottom: 24px;
    }
    .inputNew {
        height: 47px;
        border-radius: 3px;
        border: 1px solid #dcdcdc;
        background: #fff;
    }
`;

export default ModalConfirmVersionStyle;
